import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InactiveIcon from '@mui/icons-material/Block';
import InvitedIcon from '@mui/icons-material/MailOutlined';
import ActiveIcon from '@mui/icons-material/DoneAll';
import WarningIcon from '@mui/icons-material/Warning';
import { green, grey, orange } from '@mui/material/colors';
import Spacings from '~/modules/ui-kit/spacings';
import InviteButton from './InviteButton';
import LockButton from './LockButton';
import messages from './messages';
import { useIntl } from 'react-intl';

type UserStatusProps = {
  publisher: {
    id: number;
  };
  state?: string;
};

const getStateIcon = (state: state) => {
  switch (state) {
    case 'Inactive':
      return <InactiveIcon style={{ color: grey[300] }} />;
    case 'Invited':
      return <InvitedIcon style={{ color: orange[300] }} />;
    case 'AtRiskToBecomeInactive':
      return <WarningIcon style={{ color: orange[300] }} />;
    default:
      return <ActiveIcon style={{ color: green[500] }} />;
  }
};

type state = 'Inactive' | 'Invited' | 'Active' | 'AtRiskToBecomeInactive';

const isValidState = (state: string): state is state => {
  return ['Inactive', 'Invited', 'Active', 'AtRiskToBecomeInactive'].includes(
    state
  );
};

export const UserStatus = (props: UserStatusProps) => {
  const intl = useIntl();
  if (!props.state || !isValidState(props.state)) {
    return null;
  }

  return (
    <>
      <ListItem>
        <ListItemIcon>{getStateIcon(props.state)}</ListItemIcon>
        <ListItemText
          primary={
            isValidState(props.state) && messages[`state${props.state}`]
              ? intl.formatMessage(messages[`state${props.state}`])
              : props.state
          }
          secondary={intl.formatMessage(messages.state)}
        />
      </ListItem>
      <Spacings.Inset>
        <Spacings.Inline alignItems="center">
          {props.state === 'Inactive' && (
            <InviteButton publisherId={props.publisher.id} />
          )}
          {props.state !== 'Inactive' && (
            <LockButton publisherId={props.publisher.id} />
          )}
        </Spacings.Inline>
      </Spacings.Inset>
    </>
  );
};

export default UserStatus;
